// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"32":"b47532a3","321":"0d36a1a5","804":"f4d274b3"}[chunkId] + ".js";
};